// extracted by mini-css-extract-plugin
export var extra = "contentFooter-module--extra--1hENx";
export var link = "contentFooter-module--link--D0JKn";
export var logo = "contentFooter-module--logo--3Y0Xy";
export var logos = "contentFooter-module--logos--3nWRx";